import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  EventEmitter
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  Marker,
  ApplicationRouteURL,
  PermissionType,
  RoleLevel
} from '../../shared/config';
import { Location } from '@angular/common';
import { FileUploader } from 'ng2-file-upload';
import {
  SignupFormConfigModel,
  SubscriptionForSignupForm
} from '../models/signupformconfig.model';
import { SignupFormConfigService } from '../models/signupfromconfig.service';
import { InstanceService } from '../../instance/models/instance.service';
import { InstanceModel } from '../../instance/models/instance.model';
import { OrganizationModel } from '../../organization/models/organization.model';
import { OrganizationService } from '../../organization/models/organization.service';
import { DropdownModel } from '../../report/models/report-filter.model';

//const $ = require("jquery");

@Component({
  selector: 'wego-signupFormConfig',
  template: require('../views/signupformconfig-update.compnent.html'),
  providers: [SignupFormConfigService, InstanceService, OrganizationService],
  styles: [
    `
      .scroll-bar {
        overflow: auto;
        height: 200px;
      }

      .padding-left {
        padding-left: 0px;
      }
    `
  ]
})
export class SignupFormConfigUpdateComponent implements OnInit, OnDestroy {
  urlSVGInfo: string;
  signupUrl: string;
  SvgList: string[];
  svgFilter: any;
  //SubscriptionList: SubscriptionListForSignupForm[];
  //FullSubscriptionList: SubscriptiopnListForSignupForm[];
  urlSignupFormConfigList: string;
  InstanceList: DropdownModel[];
  SignupFormConfigHashId: string;
  sub: any;
  model: SignupFormConfigModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  apiErrorMsg: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlSignupFormList: string;
  pageName: string;
  accessDeniedErrorCode: string;
  roleLevel = RoleLevel;

  dayofWeekList: any;
  public headers: any = this.authService.GetHeaderForFile();
  public uploader: FileUploader = new FileUploader({
    url: WeGoConfig.API_POST_SIGNUP_CONFIG_DETAIL,
    headers: this.headers
  });
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  isLoading: boolean;
  private baseURL: string;
  private SelectedInstance: InstanceModel;
  public SelectedInstanceDetails: InstanceModel;
  private oganizationList: OrganizationModel[] = [];

  markerInfo: Marker;

  @ViewChild('logoFile') public logoFile: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private signupFormService: SignupFormConfigService,
    private locationService: Location,
    private instanceService: InstanceService,
    private organizationService: OrganizationService
  ) {}

  ngOnInit() {
    this.accessDeniedErrorCode = '412';
    this.pageName = 'SignupFormConfig';
    this.module = this.translate.instant('LblSignupForms');
    this.urlSignupFormConfigList = this.authService.GetURL(
      ApplicationRouteURL.URL_SIGNUPFORM_LIST
    );
    this.urlSVGInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_SVG_UPDATE
    );
    this.baseURL = window.location.origin + '/#/';
    this.signupUrl = window.location.origin + '/#/signup/';
    this.svgFilter = '';
    this.sub = this.activeRoute.params.subscribe(params => {
      this.SignupFormConfigHashId = params['id'] || '';
      if (this.SignupFormConfigHashId != '') {
        this.isEditMode = true;
        this.GetSignupFormDetailByHashId();
      } else {
        this.isEditMode = false;
        this.GetInstanceDropDownList(PermissionType.INSERT);
        this.model = new SignupFormConfigModel();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant('LblEditPage', [this.module])
      : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  public GetInstanceDropDownList(permissionType: string) {
    this.instanceService
      .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
      .subscribe(
        (res: any) => {
          this.InstanceList = res.data;
          if (this.InstanceList.length == 0) {
            this.authService.HandleErrorStatusCode(this.accessDeniedErrorCode);
          }

          if (this.InstanceList && this.InstanceList.length > 0) {
            if (!this.model.instanceHashId && this.InstanceList.length == 1) {
              this.model.instanceHashId = this.InstanceList[0].keyHash;
            }
            this.GetOrganizationDropDownList();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  GetSignupFormDetailByHashId() {
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlSignupFormList = this.authService.GetURL(
      ApplicationRouteURL.URL_SIGNUPFORM_LIST
    );
    this.model = new SignupFormConfigModel();

    this.signupFormService
      .GetSignupFormByHashId(this.SignupFormConfigHashId)
      .subscribe(
        res => {
          this.model = res.data;
          this.InitSubscriptionArrays();
          console.log(this.model.subscriptionList);
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  GetInstanceDetailByHashId() {
    this.instanceService
      .IsNIFNumberEnabled(this.model.instanceHashId)
      .subscribe(
        res => {
          this.apiResponse = res;
          let nifNumberEnabled: boolean = res.data;
          if (nifNumberEnabled) {
            this.model.isnifEnabled = true;
          } else {
            this.model.isnifEnabled = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetOrganizationDropDownList() {
    if (this.model.instanceHashId) {
      this.GetInstanceDetailByHashId();
      this.organizationService
        .GetOrganizationListDropdownForAddUpdatePage(
          this.pageName,
          PermissionType.INSERT,
          this.model.instanceHashId
        )
        .subscribe(
          res => {
            this.oganizationList = res.data;
            this.model.organizationHashId = '';
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.oganizationList = [];
      this.model.organizationHashId = '';
    }
  }

  GetSubscriptionList() {
    this.signupFormService
      .GetSubscriptionList(
        this.model.organizationHashId,
        this.model.signupFormConfigHashId
      )
      .subscribe(
        res => {
          this.model.subscriptionList = res.data;
          this.InitSubscriptionArrays();
          let SelectedInstance = this.InstanceList.find(
            x => x.keyHash == this.model.instanceHashId
          );
          if (SelectedInstance.data.validateLiceanceNumber) {
            this.model.validateLiceanceNumber = true;
            this.model.sendActivationMail = true;
            this.model.fieldPassword = false;
          } else {
            this.model.validateLiceanceNumber = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  InitSubscriptionArrays() {
    this.svgFilter = '';
    this.SvgList = [];
    this.model.subscriptionList.forEach(x => {
      x.hide = false;
      if (this.SvgList.indexOf(x.svgName) < 0) {
        this.SvgList.push(x.svgName);
      }
    });
  }

  SVGFilterChanged() {
    if (this.SvgList.indexOf(this.svgFilter) >= 0) {
      this.model.subscriptionList.forEach(x => {
        if (!(this.svgFilter == x.svgName)) {
          x.hide = true;
        } else {
          x.hide = false;
        }
      });
    } else {
      this.model.subscriptionList.forEach(x => {
        x.hide = false;
      });
    }
  }

  // OnSubsriptionSort(fieldName: string) {

  //     this.model.subscriptionListSortReverse = !this.model.subscriptionListSortReverse;

  //     this.model.subscriptionList = this.model.subscriptionList.sort((a: SubscriptionForSignupForm, b: SubscriptionForSignupForm) => {
  //         let retval = 0;
  //         let val1 = "";
  //         let val2 = "";
  //         if (fieldName == "subscriptionName") {
  //             val1 = a.subscriptionName;
  //             val2 = b.subscriptionName;
  //         } else if (fieldName == "statusString") {
  //             val1 = a.statusString;
  //             val2 = b.statusString;
  //         } else if (fieldName == "svgName") {
  //             val1 = a.svgName;
  //             val2 = b.svgName;
  //         }
  //         if (val1 < val2) {
  //             //a is the Object and args is the orderBy condition (data.likes.count in this case)
  //             retval = - 1;
  //         } else if (val1 > val2) {
  //             retval = 1;
  //         } else {
  //             retval = 0;
  //         }
  //         if (!this.model.subscriptionListSortReverse) {
  //             return retval * -1;
  //         }
  //         else {
  //             return retval;
  //         }
  //     }
  //     );
  // }

  OnSubscriptionCheck(
    event: Event,
    data: SubscriptionForSignupForm,
    list: SubscriptionForSignupForm[]
  ) {
    if (event.currentTarget['checked']) {
      this.model.subscriptionList
        .filter(
          x =>
            x.isChecked &&
            data.svgName == x.svgName &&
            !(data.subscriptionHashId == x.subscriptionHashId)
        )
        .forEach(x => (x.isChecked = false));
    }
  }

  OnSubmit(forms: any) {
    this.isLoading = true;
    if (!this.model.sendActivationMail) {
      this.model.fieldPassword = true;
    } else {
      this.model.fieldPassword = false;
    }
    if (this.uploader.queue && this.uploader.queue.length > 0) {
      this.uploader.onBuildItemForm = (fileItem: any, Form: any) => {
        console.log(JSON.stringify(this.model));
        Form.append('signupFormData', JSON.stringify(this.model));
      };
      var apiresponse: any;
      var status: any;
      this.uploader.onCompleteItem = (
        item: any,
        response: any,
        status: any,
        headers: any
      ) => {
        this.isLoading = false;
        if (status == 200) {
          apiresponse = JSON.parse(response);
          console.log(apiresponse.error);
          if (apiresponse.data == true) {
            this.popupMsg = this.isEditMode
              ? this.translate.instant('LblRecordUpdatedSuccess', [this.module])
              : this.translate.instant('LblRecordAddedSuccess', [this.module]);
            this.ShowSuccessPopup();
          } else {
            this.errorModel = apiresponse.error;
            this.ClearFileInput();
          }
        }
      };
      this.uploader.uploadAll();
    } else {
      this.signupFormService
        .UpdateSignupFormConfig(
          'signupFormData=' + encodeURIComponent(JSON.stringify(this.model))
        )
        .subscribe(
          res => {
            if (res.data) {
              this.popupMsg = this.isEditMode
                ? this.translate.instant('LblRecordUpdatedSuccess', [
                    this.module
                  ])
                : this.translate.instant('LblRecordAddedSuccess', [
                    this.module
                  ]);
              this.ShowSuccessPopup();
              this.isLoading = false;
            } else {
              this.errorModel = res.error;
              this.isLoading = false;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }

  public ClearFileInput() {
    console.log(this.logoFile);
    if (this.logoFile.nativeElement) {
      console.log(this.logoFile.nativeElement.value);
      this.logoFile.nativeElement.value = '';
      this.uploader.clearQueue();
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/components/signupformconfig-update.compnent.ts